<template>
  <div>
    <sweet-modal :title="$t('settings_accountThink_GLAccounts_createOpeningBalanceTransaction')" blocking width="940" ref="modal" class="modal" v-on:close="close">
      <div style="display:flex; justify-content: space-between; align-items: center;">
        <h4>{{$t('settings_accountThink_GLAccounts_accountName')}}: {{params.data.name}}</h4>
        <div>
          <h4 v-if="state === 'update'">Transaction ID: <span style="cursor: pointer; color: #409EFF;" @click="openJournalEntry">{{transactionNo}}</span></h4>
          <h4 v-if="state === 'update'">Status: {{ isPosted ? 'Posted' : 'Added' }}</h4>
        </div>
      </div>
      <el-form :model="form2" size="mini" ref="form2" status-icon label-position="left">
        <div>
          <div style="margin-bottom:22px;">
            <el-form-item
                prop="amount"
                style="margin-bottom:0;">
              <div style="display: flex; align-items: center;">
                <div>
                  <money
                      v-if="state === 'update'"
                      :style="{background: editMode ? 'transparent' : 'rgba(201, 202, 205, 0.5)'}"
                      v-model="form2.amount"
                      v-bind="money"
                      class="amount-input"
                      :disabled="!editMode">
                  </money>
                  <money
                      v-else
                      v-model="form2.amount"
                      v-bind="money"
                      class="amount-input"
                      :class="{readonly: state === 'update'}">
                  </money>
                </div>
                <span style="margin-left: 10px;">{{params.data.DRCRCode === 'DR' ? $t('settings_accountThink_GLAccounts_debit') : $t('settings_accountThink_GLAccounts_credit')}}</span>
                <el-button
                    v-if="state === 'update'"
                    style="margin-left: 20px;"
                    :icon="editMode ? 'el-icon-check' : 'el-icon-edit-outline'"
                    @click="updateAccount">
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
                prop="foreignAmount"
                style="margin-top: 15px;">
              <div style="display: flex; align-items: center;">
                <div>
                  <money
                      v-if="state === 'update'"
                      :style="{background: editMode ? 'transparent' : 'rgba(201, 202, 205, 0.5)'}"
                      v-model="form2.foreignAmount"
                      v-bind="moneyForeign"
                      class="amount-input"
                      :disabled="!editMode">
                  </money>
                  <money
                      v-else
                      v-model="form2.foreignAmount"
                      v-bind="moneyForeign"
                      class="amount-input"
                      :class="{readonly: state === 'update'}">
                  </money>
                </div>
              </div>
            </el-form-item>
            <el-form-item
                prop="rate"
                style="margin-bottom:15px; margin-top: 15px;">
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;">
                  Rate
                </span>
                <div>
                  {{form2.foreignAmount && form2.amount ? formatPrice(form2.foreignAmount / form2.amount ) : '0.00' }}
                </div>
              </div>
            </el-form-item>
            <el-form-item
                :label="$t('settings_accountThink_GLAccounts_date')"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }"
                prop="date">
              <el-date-picker type="date"
                              class="date-input"
                              format="d MMM yy"
                              readonly
                              v-model="form2.date"
                              value-format="DD-MM-yyyy"
                              :picker-options="pickerOptions2">
              </el-date-picker>
            </el-form-item>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <div style="display: flex; align-items: center; align-self: flex-end; width: 440px;">
                <el-form-item style="margin-bottom: 0; width: 100%;" :label="$t('modal_description')" prop="transactionDescription">
                  <el-input
                      type="textarea"
                      :rows="2"
                      v-model="form2.transactionDescription">
                  </el-input>
                </el-form-item>
              </div>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <p>{{$t('settings_accountThink_GLAccounts_linkedAccount')}}</p>
                  <p>{{$t('settings_accountThink_equity-openingBalance')}}</p>
                </div>
                <div style="display: flex; align-items: center;">
                  <money
                      style="background: rgba(201, 202, 205, 0.5);"
                      v-model="form2.amount"
                      v-bind="money"
                      class="amount-input"
                      disabled></money>
                  <span style="margin-left: 10px;">
                {{params.data.DRCRCode === 'DR' ? $t('settings_accountThink_GLAccounts_credit') : $t('settings_accountThink_GLAccounts_debit')}}
              </span>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <div style="margin-top:20px;">
          <el-table
              v-if="allocations.length"
              size="mini"
              border
              :data="allocations"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              @cell-click="cellClick">
            <el-table-column
                label="ID"
                width="70">
              <template slot-scope="scope">
                <span style="cursor: pointer; color: #409EFF;">{{scope.row.transactionNo}}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="100"
                :label="'Amount ' + companyLayout.currency.code">
              <template slot-scope="scope">
                <div style="text-align: right;">{{formatPrice(scope.row.amount)}}</div>
              </template>
            </el-table-column>
            <el-table-column
                width="100"
                :label="'Amount ' + this.currencyForeign.code">
              <template slot-scope="scope">
                <div style="text-align: right;">{{formatPrice(scope.row.foreignAmount)}}</div>
              </template>
            </el-table-column>
            <el-table-column
                width="120"
                label="Date">
              <template slot-scope="scope">
                {{moment(scope.row.transactionDate).format('D MMM YY')}}
              </template>
            </el-table-column>
            <el-table-column
                label="Description"
                prop="transactionDescription">
            </el-table-column>
            <el-table-column
                width="70"
                label="Action">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <el-button
                      @click="deleteAllocation(scope.row)"
                      size="mini"
                      plain>
                    <i class="fas fa-trash"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; justify-content: space-between;">
            <div style="max-width:400px; width:100%;">
              <el-card v-if="allocations.length" style="margin-top: 20px; max-width: 400px; width:100%;">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <h4 style="display: flex; flex-direction: column;">
                      <span>Total Allocations: </span>
                      <span>{{formatPrice(totalAmount)}}</span>
                    </h4>
                    <h4 style="display: flex; flex-direction: column;">
                      <span>Balance to Allocate: </span>
                      <span>{{formatPrice(balanceToAllocate())}}</span>
                    </h4>
                  </div>
                  <div>
                    <h4 style="display: flex; flex-direction: column;">
                      <span>Total Allocations in {{moneyForeign.suffix}}: </span>
                      <span>{{formatPrice(totalAmountForeign)}}</span>
                    </h4>
                    <h4 style="display: flex; flex-direction: column;">
                      <span style="height:21px;"></span>
                      <span>{{formatPrice(balanceToAllocateForeign())}}</span>
                    </h4>
                  </div>
                </div>
                <p>Posted to Subsidiary ledger</p>
              </el-card>
            </div>
            <el-form-item class="modal__btn" style="margin-bottom: 0; display:flex; align-self: flex-end">
              <el-button
                  size="medium"
                  @click="closeModal">
                Close
              </el-button>
              <el-button
                  v-if="state === 'update' && !isPosted"
                  @click="deleteOpenBalance"
                  size="medium"
                  plain>
                Delete
              </el-button>
              <el-button
                  v-if="state !== 'update'"
                  @click="record('form2', 'add')"
                  type="primary"
                  size="medium">
                Add
              </el-button>
              <el-button
                  v-if="state === 'update'"
                  type="primary"
                  size="medium"
                  @click="openSecondaryModal">
                Add Allocations
              </el-button>
              <el-button
                  v-if="state === 'update' && !isPosted"
                  :disabled="balanceToAllocate() !== 0"
                  @click="record('form2', 'post')"
                  type="primary"
                  size="medium">
                Post
              </el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </sweet-modal>
    <c-o-a-add-vendor-client-multi-currency-allocation-modal
        :amount="allocations.length ? balanceToAllocate() : form2.amount"
        :foreignAmount="allocations.length ? balanceToAllocateForeign() : form2.foreignAmount"
        :currencyForeign="currencyForeign"
        :DRCRCode="params.data.DRCRCode"
        :transactionNo="transactionNo"
        :transactionId="item[0].id"
        :accountName="params.data.name"
        :rate="form2.foreignAmount && form2.amount ? formatPrice(form2.foreignAmount / form2.amount ) : '0.00'"
        :date="form2.date"
        :accountId="params.data.id"
        :accountTypeId="params.data.accountTypeId"
        :transactionCurrency="companyLayout.currency.code"
        ref="allocationsModal"
        @openJournal="openJournalEntry"
        @loadItem="loadItem"/>
    <c-o-a-vendor-client-multi-currency-info-modal
        :currencyForeign="currencyForeign"
        :accountTypeId="params.data.accountTypeId"
        ref="allocationsInfoModal"/>
    <edit-journal-entry-modal
        :showInfo="false"
        ref="editJournalEntryModal"/>
  </div>
</template>

<script>
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";
import { Money, VMoney } from 'v-money'
import axios from 'axios'
import moment from "moment";
import COAAddVendorClientMultiCurrencyAllocationModal from "./COAAddVendorClientMultiCurrencyAllocationModal";
import COAVendorClientMultiCurrencyInfoModal from "./COAVendorClientMultiCurrencyInfoModal";
import EditJournalEntryModal from "../../../journalAndGl/editJournalEntryModal";
export default {
  name: "COAAddVendorClientMultiCurrencyAccountTransactionModal",
  components: {
    EditJournalEntryModal,
    COAVendorClientMultiCurrencyInfoModal,
    COAAddVendorClientMultiCurrencyAllocationModal,
    SweetModal,
    Money
  },
  props: {
    financialYearStartDate: {
      type: String,
      default: null
    },
    currencyList: {
      type: Array,
      default: () => ([])
    }
  },
  directives: {money: VMoney},
  computed: {
    totalAmount() {
      const amount = this.allocations.map(val => val.amount).reduce((sum, curr) => {
        return !curr ? sum : parseFloat(curr) + sum
      }, 0)
      return amount
    },
    totalAmountForeign() {
      const amount = this.allocations.map(val => val.foreignAmount).reduce((sum, curr) => {
        return !curr ? sum : parseFloat(curr) + sum
      }, 0)
      return amount
    },
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    currencyForeign() {
      return this.currencyList.find(val => val.id === this.params.data.accountCurrencyId)
    }
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value <= 0) return callback(new Error(this.$t('modal_settings_fieldIsRequired')))
      callback();
    }
    return {
      moment: moment,
      validateAmount: validateAmount,
      state: 'create',
      transactionNo: null,
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      moneyForeign: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      form2: {
        amount: 0,
        date: null,
        foreignAmount: 0,
        transactionDescription: null
      },
      entityTypeList: [
        { id: 1, name: 'Project' },
        { id: 2, name: 'Business Unit' },
        { id: 3, name: 'Engagement' }
      ],
      vendorClientList: [
        { id: 'vendor', name: 'Vendor' },
        { id: 'client', name: 'Client' }
      ],
      params: {
        data: {
          id: null,
          name: '',
          DRCRCode: 'DR',
          accountCurrencyId: null,
          accountTypeId: 0
        }
      },
      item: [{ id: null }],
      allocations: [],
      pickerOptions2: {
        disabledDate: this.disabledDates
      },
      isPosted: null,
      accountId: null,
      editMode: false
    }
  },
  methods: {
    openModal(params) {
      this.form2.date = this.financialYearStartDate ? this.financialYearStartDate : '01-01-2022'
      this.params = params
      this.money.suffix = ' ' + this.companyLayout.currency.code
      this.moneyForeign.suffix = ' ' + this.currencyForeign.code
      this.$refs.modal.open()
    },
    async openModalEdit(params) {
      try {
        this.state = 'update'
        this.money.suffix = ' ' + this.companyLayout.currency.code
        this.params = params
        this.moneyForeign.suffix = ' ' + this.currencyForeign.code
        await this.loadItem()
        this.$refs.modal.open()
      } catch (err) {
        console.log(err)
      }
    },
    async loadItem() {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const item = await axios.get(`/api/v1/accountTransaction/item?accountId=${this.params.data.id}`)
        this.transactionNo = item.data.item[0].transactionNo
        this.isPosted = item.data.item[0].isPosted
        this.accountId = item.data.item[0].accountId
        this.item = item.data.item
        this.allocations = item.data.item.filter((val, index) => index > 0)
        this.form2.amount = item.data.item[0].amount
        this.form2.date = item.data.item[0].transactionDate
        this.form2.foreignAmount = item.data.item[0].foreignAmount
        this.form2.transactionDescription = item.data.item[0].transactionDescription
        loader.hide()
      } catch(err) {
        console.log(err)
        loader.hide()
      }
    },
    record(form, status) {
      if (status === 'post') {
        this.$confirm('Are you sure you want to Post transaction?', this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/accountTransaction/postOpenBalance?id=${this.item[0].id}`)
              .then(response => {
                this.notification(this.$t('general_success'), this.$t('setting_transactionPosted'), "success");
                this.$emit('loadList')
                this.loadItem()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        })
      } else {
        if (!this.form2.amount || this.form2.amount <= 0 || !this.form2.foreignAmount || this.form2.foreignAmount <= 0) {
          return this.notification("Notification",'Opening Balance is required', "info")
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            const payload = {
              amount: parseFloat(this.form2.amount),
              foreignAmount: parseFloat(this.form2.foreignAmount),
              date: this.form2.date,
              transactionDescription: this.form2.transactionDescription,
              transactionId: 1,
              status: status,
              accountId: this.params.data.id,
              transactionCurrency: this.companyLayout.currency.code,
              foreignCurrency: this.currencyForeign.code
            }

            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/accountTransaction/createOpenBalance?companyId=${this.$route.query.companyId}`, payload)
                .then(response => {
                  this.notification(this.$t('general_success'), this.$t('setting_transactionCreated'), "success");
                  this.$emit('loadList')
                  this.loadItem()
                  loader.hide()
                  this.state = 'update'
                  this.transactionNo = response.data.newTransaction.transactionNo
                  // this.$refs.modal.close()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
          }
        })
      }
    },
    close() {
      this.state = 'create'
      this.transactionNo = null
      this.params = {
        data: {
          id: null,
          name: '',
          DRCRCode: 'DR',
          accountCurrencyId: null,
          accountTypeId: 0
        }
      }
      this.money.suffix = ''
      this.moneyForeign.suffix = ''
      this.form2.amount = 0
      this.form2.date = moment().format('x')
      this.form2.foreignAmount = 0
      this.form2.transactionDescription = null
      this.allocations = []
      this.item = [{ id: null }]
      this.$refs['form2'].resetFields()
      this.isPosted = false
      this.accountId = null
      this.editMode = false
      this.$emit('closeModal')
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    cellClick(val, column) {
      if (column.label === 'ID') {
        this.$refs['editJournalEntryModal'].openModalFromJournalEntry({ status: 'Check', id: val.id })
      } else if (column.label !== 'Action') {
        this.$refs.allocationsInfoModal.openModal(val)
      }
    },
    tableRowClassName({row, rowIndex}) {
      return 'cursor-pointer';
    },
    updateAccount() {
      if (!this.editMode) {
        return this.editMode = true
      }
      this.editMode = false

      const payload = {
        amount: parseFloat(this.form2.amount),
        transactionDescription: this.form2.transactionDescription,
        transactionCurrency: this.item[0].transactionCurrency,
        foreignCurrency: this.currencyForeign.code,
        foreignAmount: this.form2.foreignAmount,
        date: this.form2.date
      }

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/accountTransaction/updateOpenBalance?id=${this.item[0].id}`, payload)
          .then(response => {
            this.loadItem()
            loader.hide()
            this.$emit('loadList')
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    balanceToAllocate() {
      return this.form2.amount - this.totalAmount
    },
    balanceToAllocateForeign() {
      return this.form2.foreignAmount - this.totalAmountForeign
    },
    openSecondaryModal() {
      this.$refs.allocationsModal.openModal()
    },
    closeModal() {
      this.$refs.modal.close()
    },
    deleteAllocation(row, closeModal) {
      this.$confirm("Delete transaction?", this.$t('general_info'), {
        distinguishCancelAndClose: true,
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(async () => {
        const loader = this.$loading.show();
        await axios.get(`api/v1/accountTransaction/delete?transactionId=${row.id}&companyId=${this.$route.query.companyId}&transactionNo=${row.transactionNo}`)
        await this.loadItem()
        loader.hide()
        if (closeModal) {
          this.$emit('loadList')
          this.$refs.modal.close()
        }
      }).catch(action => {
        console.log('action', action)
      });
    },
    deleteOpenBalance() {
      this.$confirm("Delete transaction?", this.$t('general_info'), {
        distinguishCancelAndClose: true,
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(async () => {
        const loader = this.$loading.show();
        await axios.get(`api/v1/accountTransaction/deleteOpenBalance?transactionId=${this.item[0].id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&accountId=${this.params.data.id}`)
        loader.hide()
        this.$emit('loadList')
        this.$refs.modal.close()
      }).catch(action => {
        console.log('action', action)
      });
    },
    disabledDates (time) {
      let start = time.getTime() < Number(moment().subtract(1, 'years').format('x'));
      let end = time.getTime() > Number(moment().format('x'));
      if (start){
        return start
      }else if(end){
        return end
      }
    },
    openJournalEntry() {
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry({ status: 'Check', id: this.item[0].id })
    }
  }
}
</script>

<style lang="less" scoped>
.amount-input {
  display: block;
  resize: vertical;
  padding: 0 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  //transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
  &.readonly {
    background: rgba(201, 202, 205, 0.5);
  }
}
.item-amount-input {
  display: block;
  resize: vertical;
  padding: 0 5px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  //transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
}
/deep/.cursor-pointer {
  cursor: pointer;
}
</style>

<style lang="less">
.sweet-modal-overlay{
  .sweet-modal {
    max-width: 1000px !important;
  }
}
</style>
